import { Badge } from "@/components/ui/badge";
import { CircleDot } from "lucide-react";

const variants = {
  idle: { cls: 'bg-muted text-muted-foreground border-border', label: 'Sessão do navegador: inativa' },
  loading: { cls: 'bg-[hsl(var(--info))]/15 text-[hsl(var(--info))] border-[hsl(var(--info))]/30', label: 'Sessão do navegador: a carregar…' },
  ready: { cls: 'bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] border-[hsl(var(--success))]/30', label: 'Sessão do navegador: pronta' },
  closed: { cls: 'bg-muted text-muted-foreground border-border', label: 'Sessão do navegador: fechada' },
  error: { cls: 'bg-destructive/15 text-destructive border-destructive/30', label: 'Sessão do navegador: erro' },
};

export default function SessionPill({ status = 'idle' }) {
  const v = variants[status] || variants.idle;
  return (
    <Badge data-testid="browser-session-status-pill" variant="outline" className={`gap-1.5 ${v.cls}`}>
      <CircleDot className={`h-3 w-3 ${status==='loading' ? 'animate-pulse' : ''}`}/> {v.label}
    </Badge>
  );
}
